import React from 'react';
import Banner1 from '../assets/images/banner1.png';
import Banner2 from '../assets/images/banner2.png';
import Banner3 from '../assets/images/banner3.png';
import Wrapper from '../assets/wrappers/SabhaCarousel';
import PmModiImg from '../assets/images/pmModi.png';

const SabhaCarousel: React.FC = () => {
  return (
    <Wrapper>
      <div className="row g-3 align-items-stretch mt-1">
        {/* Card 1: Carousel Section */}
        <div className="col-12 col-md-9 d-flex">
          <div className="card-box w-100 p-2">
            <div id="sabhaCarousel" className="carousel slide h-100" data-bs-ride="carousel">
              <div className="carousel-indicators">
                <button
                  type="button"
                  data-bs-target="#sabhaCarousel"
                  data-bs-slide-to="0"
                  className="active"
                  aria-current="true"
                  aria-label="Slide 1"
                ></button>
                <button
                  type="button"
                  data-bs-target="#sabhaCarousel"
                  data-bs-slide-to="1"
                  aria-label="Slide 2"
                ></button>
                <button
                  type="button"
                  data-bs-target="#sabhaCarousel"
                  data-bs-slide-to="2"
                  aria-label="Slide 3"
                ></button>
              </div>

              <div className="carousel-inner h-100">
                <div className="carousel-item active h-100">
                  <img src={Banner3} className="d-block w-100 h-100" alt="Banner 3" />
                </div>
                <div className="carousel-item h-100">
                  <img src={Banner2} className="d-block w-100 h-100" alt="Banner 2" />
                </div>
                <div className="carousel-item h-100">
                  <img src={Banner1} className="d-block w-100 h-100" alt="Banner 1" />
                </div>
              </div>

              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#sabhaCarousel"
                data-bs-slide="prev"
              >
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
              </button>

              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#sabhaCarousel"
                data-bs-slide="next"
              >
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
        </div>

        {/* Card 2: PM Profile Section */}
        <div className="col-12 col-md-3 d-flex">
          <div className="card-box w-100 p-2 d-flex flex-column align-items-center justify-content-center">
            <div className="pm-card-container text-center">
              <div className="pm-img-frame">
                <img
                  src={PmModiImg}
                  alt="Shri Narendra Modi"
                  className="img-fluid"
                />
              </div>
              <h5 className="pm-name mt-2">Shri Narendra Modi</h5>
              <p className="pm-title">Hon'ble Prime Minister</p>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default SabhaCarousel;